<template>
  <!-- Wrapping v-text-field in a div component seems problematic. It prevents this component from filling the width of its parent, which is supposed
    to be default behavior. Before removing it, however, an audit check would need to be performed to ensure that doesn't impact existing UI. -->
  <div>
    <v-text-field
      ref="textField"
      v-bind="effectiveBindings"
      class="sn-text-field"
      :data-cy="dataCy || 'text-field'"
      data-lpignore="true"
      v-on="$listeners"
    >
      <slot
        v-if="!this.$slots.label && effectiveLabelProps"
        slot="label"
        name="label"
      >
        <sn-label
          class="mb-2"
          v-bind="effectiveLabelProps"
        />
      </slot>

      <slot
        v-for="slot in Object.keys($slots)"
        :slot="slot"
        :name="slot"
      />
    </v-text-field>
  </div>
</template>

<script>
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'
import labeledComponentMixin from '~/components/snui/v2/mixins/labeledComponentMixin.js'
import { cypressMixin } from '../mixins/cypressMixin'

export default {
  name: 'SnTextField',
  mixins: [vuetifyOverrideMixin, cypressMixin, labeledComponentMixin],
  data () {
    return {
      vuetifyOverrideMixin: {
        defaultProps: {
          hideDetails: 'auto'
        },
        overriddenProps: {
          // Supported text-field props
          /*
            appendIcon: undefined,
            label: undefined,
          */
          appendOuterIcon: undefined,
          backgroundColor: undefined,
          clearIcon: '$snExit',
          color: undefined,
          counter: undefined,
          counterValue: null,
          dark: false,
          dense: false,
          errorCount: 1,
          filled: false,
          flat: false,
          fullWidth: false,
          hideSpinButtons: false,
          light: false,
          loaderHeight: 2,
          loading: false,
          messages: [],
          outlined: false,
          persistentHint: true,
          persistentPlaceholder: false,
          prependIcon: undefined,
          prependInnerIcon: undefined,
          reverse: false,
          shaped: false,
          singleLine: false,
          solo: false,
          soloInverted: false,
          success: false,
          successMessages: []
        }
      }
    }
  },
  computed: {
    effectiveBindings () {
      var bindings = {
        ...this.vuetifyOverrideMixin.bindings
      }
      return bindings
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/components/snui/v2/mixins/vuetifyOverrideCss.scss';

.sn-text-field {
  @extend .v-text-field--sn_override;
}

</style>
